import React, { useContext } from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import { styles } from '@tag/tag-components-react-v2';

import { ConfluenceIcon } from './ConfluenceIcon';
import { JiraIcon } from './JiraIcon';
import { SlackIcon } from './SlackIcon';
import { darkModeContext } from '../darkModeContext';

export const Footer = () => {
  const docsDarkMode = useContext(darkModeContext);
  const docsDarkModeValue = docsDarkMode.value || false;
  return (
    <footer
      css={css`
        box-sizing: border-box;
        margin: 10px 0px 0px;
        padding: 15px 0px;
        border-top: ${docsDarkModeValue ? '1px solid #000' : '1px solid #dfdfdf'};
        text-align: center;
        display: flex;
        justify-content: center;
        background-colour: ${docsDarkModeValue ? '#000' : undefined}
        colour: ${docsDarkModeValue ? undefined : '#fff'}
      `}
    >
      <FooterLink
        href="https://dev.azure.com/access-devops/Access%20Tag%20Components/_wiki/wikis/Access-Tag-Components.wiki/74822/tag-components"
        icon={<ConfluenceIcon />}
      >
        tag-component wiki
      </FooterLink>
      <FooterLinkSeparator />
      <FooterLink
        href="https://dev.azure.com/access-devops/Access%20Workspace/_wiki/wikis/Access-Workspace.wiki/13588/Workspace-Wiki"
        icon={<ConfluenceIcon />}
      >
        Workspace wiki
      </FooterLink>
      <FooterLinkSeparator />
      <FooterLink
        href="https://dev.azure.com/access-devops/Access%20Workspace/_boards/board/t/Prometheus%20Squad/Stories"
        icon={<JiraIcon />}
      >
        Azure
      </FooterLink>
      <FooterLinkSeparator />
      <FooterLink
        href="https://teams.microsoft.com/l/channel/19%3Ad6671164aff549f09c8548c43f73bb18%40thread.tacv2/Tag%20Component%20Forum?groupId=11747135-a331-43a3-a333-0f70f5733932"
        icon={<JiraIcon />}
      >
        Tag Component Forum
      </FooterLink>
    </footer>
  );
};

type FooterLinkProps = {
  icon?: JSX.Element;
  href?: string;
};
const FooterLink: React.FC<FooterLinkProps> = ({ href, icon, children }) => {
  const docsDarkMode = useContext(darkModeContext);
  const docsDarkModeValue = docsDarkMode.value || false;
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
      `}
    >
      {icon !== undefined && (
        <div
          css={css`
            margin-right: 3px;
          `}
        >
          {icon}
        </div>
      )}
      {href ? (
        <a
          href={href}
          css={css`
            text-decoration: none;
            font-size: 12px;
            color: ${docsDarkModeValue ? '#fff' : styles.colours.text};
          `}
        >
          {children}
        </a>
      ) : (
        <span
          css={css`
            text-decoration: none;
            font-size: 12px;
            color: ${docsDarkModeValue ? '#fff' : styles.colours.text};
          `}
        >
          {children}
        </span>
      )}
    </div>
  );
};

const FooterLinkSeparator = () => (
  <span
    css={css`
      margin-left: 5px;
      margin-right: 5px;
    `}
  >
    |
  </span>
);
